import axios from "axios";
import config from '@/data/config';

const API_URL = config.baseURL + "auth/";

class AuthService {
   login(user) {
      return axios
         .post(API_URL + "login", {
            username: user.username,
            password: user.password,
         })
         .then((response) => {
            localStorage.setItem("user", JSON.stringify(response.data));

            return response.data;
         });
   }
   register(user) {
      return axios.post(API_URL + "signup", {
         username: user.username,
         email: user.email,
         password: user.password
      });
   }
   logout() {
      localStorage.removeItem("user");
   }
}

export default new AuthService();
